import { Filtro } from './Filtro';

export default class FiltroMotivoRemessaJulgamento extends Filtro {
    tipo = 'selecao';
    exibicao = 'select';
    selecaoMultipla = true;

    get label() {
        return 'Motivo de remessa de julgamento';
    }

    constructor(props) {
        super(props);
    }

    getValorOpcao(registro) {
        const valorOpcao = registro?.remessaJulgamento?.complemento?.trim();

        if (valorOpcao) {
            return valorOpcao;
        }

        if (registro?.remessaJulgamento?.tipo?.id) {
            return 'Sem motivo informado';
        }

        return '';
    }

    getDescricao(valor) {
        const descricao = valor?.trim();
        return descricao || 'Sem complemento';
    }

    equals(valor1, valor2) {
        return valor1 !== undefined && valor2 !== undefined && valor1 === valor2;
    }
}
